import React from 'react';
import {Cascader} from 'antd';
import commonExtendsHOC from '../../commonExtendsHOC';

export default commonExtendsHOC(Cascader);